/* Shared design themes and size configs for product views */

export const themes = {
  'modern-minimal': {
    name: 'Modern Minimal',
    bg: '#FFFCF9', cardBg: '#FFFFFF', text: '#1A1A1A', subtext: '#6B6B6B',
    accent: '#B49A88', accentLight: '#FFF0EC', fieldBg: '#FAF7F5', fieldBorder: '#E8E2DD',
    font: "'Playfair Display', serif", bodyFont: "'Manrope', sans-serif",
  },
  'soft-beige': {
    name: 'Soft Beige',
    bg: '#F5F0EB', cardBg: '#FFFCF9', text: '#2C2C2C', subtext: '#7A7066',
    accent: '#C9A193', accentLight: '#F5EDE8', fieldBg: '#F0EBE6', fieldBorder: '#DDD5CC',
    font: "'Playfair Display', serif", bodyFont: "'Manrope', sans-serif",
  },
  'bold-dark': {
    name: 'Bold Dark',
    bg: '#1A1A1A', cardBg: '#2A2A2A', text: '#F5F0EB', subtext: '#A0A0A0',
    accent: '#B49A88', accentLight: '#3A2A25', fieldBg: '#222222', fieldBorder: '#3A3A3A',
    font: "'Playfair Display', serif", bodyFont: "'Manrope', sans-serif",
  },
  'sage-nature': {
    name: 'Sage Nature',
    bg: '#F5F7F2', cardBg: '#FFFFFF', text: '#2C3B2D', subtext: '#6B7B6C',
    accent: '#A3B18A', accentLight: '#EDF2E6', fieldBg: '#F0F4EC', fieldBorder: '#D5DEC8',
    font: "'Playfair Display', serif", bodyFont: "'Manrope', sans-serif",
  },
  'blush-pink': {
    name: 'Blush Pink',
    bg: '#FFF5F5', cardBg: '#FFFFFF', text: '#2C2020', subtext: '#8B7575',
    accent: '#D4A0A0', accentLight: '#FFF0F0', fieldBg: '#FFF8F8', fieldBorder: '#E8D4D4',
    font: "'Playfair Display', serif", bodyFont: "'Manrope', sans-serif",
  }
};

export const sizeConfigs = {
  'instagram-post':  { width: 1080, height: 1080, aspect: 'aspect-square', label: 'Instagram Post' },
  'instagram-story': { width: 1080, height: 1920, aspect: 'aspect-[9/16]', label: 'Instagram Story' },
  'a4-document':     { width: 595,  height: 842,  aspect: 'aspect-[210/297]', label: 'A4 Document' },
  'us-letter':       { width: 612,  height: 792,  aspect: 'aspect-[8.5/11]', label: 'US Letter' },
  'pinterest-pin':   { width: 1000, height: 1500, aspect: 'aspect-[2/3]', label: 'Pinterest Pin' },
};

export const pageTypeMeta = {
  'intro': { label: 'Introduction', color: '#6B7B8D' },
  'monthly-overview': { label: 'Overview', color: '#4A90D9' },
  'income-tracker': { label: 'Tracker', color: '#50B86C' },
  'fixed-expenses': { label: 'Expenses', color: '#B49A88' },
  'variable-expenses': { label: 'Expenses', color: '#D97B4A' },
  'daily-expense': { label: 'Daily Log', color: '#8B6CC9' },
  'savings-goal': { label: 'Goals', color: '#50B86C' },
  'debt-tracker': { label: 'Tracker', color: '#D94A6B' },
  'monthly-review': { label: 'Review', color: '#4AD9B8' },
  'notes': { label: 'Notes', color: '#A0A0A0' },
  'tracker': { label: 'Tracker', color: '#50B86C' },
  'worksheet': { label: 'Worksheet', color: '#D9A34A' },
  'review': { label: 'Review', color: '#4AD9B8' },
  'checklist': { label: 'Checklist', color: '#6B8BD9' },
  'planner': { label: 'Planner', color: '#8B6CC9' },
  'log': { label: 'Log', color: '#4A90D9' },
  // Journal page types
  'journal-intro': { label: 'Introduction', color: '#8B6CC9' },
  'journal-daily': { label: 'Daily Entry', color: '#B49A88' },
  'journal-weekly': { label: 'Weekly Review', color: '#4A90D9' },
  'journal-prompt': { label: 'Prompt', color: '#D97B4A' },
  'journal-gratitude': { label: 'Gratitude', color: '#50B86C' },
  'journal-goals': { label: 'Goals', color: '#6B8BD9' },
  'journal-free': { label: 'Free Writing', color: '#A0A0A0' },
  'journal-reflection': { label: 'Reflection', color: '#4AD9B8' },
  // Recipe page types
  'recipe-intro': { label: 'Introduction', color: '#D97B4A' },
  'recipe-category': { label: 'Category', color: '#B49A88' },
  'recipe-card': { label: 'Recipe', color: '#50B86C' },
  'recipe-shopping': { label: 'Shopping List', color: '#6B8BD9' },
  'recipe-tips': { label: 'Tips', color: '#8B6CC9' },
  'recipe-index': { label: 'Index', color: '#A0A0A0' },
  // Memory book page types
  'memory-intro': { label: 'Introduction', color: '#D4A0A0' },
  'memory-milestone': { label: 'Milestone', color: '#B49A88' },
  'memory-timeline': { label: 'Timeline', color: '#4A90D9' },
  'memory-photo': { label: 'Photos', color: '#8B6CC9' },
  'memory-story': { label: 'Story', color: '#D97B4A' },
  'memory-keepsake': { label: 'Keepsake', color: '#A3B18A' },
  'memory-letter': { label: 'Letter', color: '#D4A0A0' },
  'memory-favorites': { label: 'Favorites', color: '#D9A34A' },
  'memory-reflection': { label: 'Reflection', color: '#4AD9B8' },
  // Travel planner page types
  'travel-intro': { label: 'Overview', color: '#4A90D9' },
  'travel-destination': { label: 'Destination', color: '#D97B4A' },
  'travel-itinerary': { label: 'Itinerary', color: '#50B86C' },
  'travel-packing': { label: 'Packing', color: '#8B6CC9' },
  'travel-budget': { label: 'Budget', color: '#B49A88' },
  'travel-accommodation': { label: 'Stay', color: '#D4A0A0' },
  'travel-food': { label: 'Food', color: '#D97B4A' },
  'travel-transport': { label: 'Transport', color: '#6B8BD9' },
  'travel-memories': { label: 'Memories', color: '#D4A0A0' },
  'travel-emergency': { label: 'Emergency', color: '#D94A6B' },
  // Fitness program page types
  'fitness-intro': { label: 'Overview', color: '#D94A6B' },
  'fitness-schedule': { label: 'Schedule', color: '#4A90D9' },
  'fitness-workout': { label: 'Workout', color: '#D94A6B' },
  'fitness-exercise': { label: 'Exercises', color: '#8B6CC9' },
  'fitness-warmup': { label: 'Warm-up', color: '#D9A34A' },
  'fitness-progress': { label: 'Progress', color: '#50B86C' },
  'fitness-nutrition': { label: 'Nutrition', color: '#B49A88' },
  'fitness-rest': { label: 'Rest Day', color: '#A3B18A' },
  'fitness-milestone': { label: 'Check-in', color: '#4AD9B8' },
  // Activity book page types
  'activity-intro': { label: 'Welcome', color: '#D9A34A' },
  'activity-creative': { label: 'Creative', color: '#8B6CC9' },
  'activity-puzzle': { label: 'Puzzle', color: '#4A90D9' },
  'activity-challenge': { label: 'Challenge', color: '#D94A6B' },
  'activity-worksheet': { label: 'Worksheet', color: '#B49A88' },
  'activity-reflection': { label: 'Reflection', color: '#4AD9B8' },
  'activity-project': { label: 'Project', color: '#50B86C' },
  'activity-game': { label: 'Game', color: '#D97B4A' },
  'activity-certificate': { label: 'Certificate', color: '#D9A34A' },
  // Reading journal page types
  'reading-intro': { label: 'Welcome', color: '#8B6CC9' },
  'reading-log': { label: 'Book Review', color: '#B49A88' },
  'reading-list': { label: 'Reading List', color: '#4A90D9' },
  'reading-challenge': { label: 'Challenge', color: '#D94A6B' },
  'reading-quotes': { label: 'Quotes', color: '#D97B4A' },
  'reading-stats': { label: 'Statistics', color: '#50B86C' },
  'reading-recommendations': { label: 'Recommendations', color: '#A3B18A' },
  'reading-reflection': { label: 'Reflection', color: '#4AD9B8' },
  'reading-notes': { label: 'Notes', color: '#A0A0A0' },
  // Pet journal page types
  'pet-intro': { label: 'Pet Profile', color: '#B49A88' },
  'pet-health': { label: 'Health', color: '#D94A6B' },
  'pet-milestone': { label: 'Milestone', color: '#D9A34A' },
  'pet-training': { label: 'Training', color: '#8B6CC9' },
  'pet-routine': { label: 'Routine', color: '#4A90D9' },
  'pet-food': { label: 'Feeding', color: '#D97B4A' },
  'pet-expense': { label: 'Expenses', color: '#50B86C' },
  'pet-photo': { label: 'Photos', color: '#D4A0A0' },
  'pet-emergency': { label: 'Emergency', color: '#D94A6B' },
  'pet-memories': { label: 'Memories', color: '#A3B18A' },
  // Pregnancy journal page types
  'pregnancy-intro': { label: 'Welcome', color: '#D4A0A0' },
  'pregnancy-weekly': { label: 'Weekly', color: '#B49A88' },
  'pregnancy-milestone': { label: 'Milestone', color: '#D9A34A' },
  'pregnancy-appointment': { label: 'Appointment', color: '#4A90D9' },
  'pregnancy-letter': { label: 'Letter', color: '#D4A0A0' },
  'pregnancy-photo': { label: 'Bump Photo', color: '#8B6CC9' },
  'pregnancy-names': { label: 'Names', color: '#A3B18A' },
  'pregnancy-checklist': { label: 'Checklist', color: '#50B86C' },
  'pregnancy-wishlist': { label: 'Wish List', color: '#D97B4A' },
  'pregnancy-birth': { label: 'Birth Plan', color: '#D94A6B' },
  'pregnancy-reflection': { label: 'Reflection', color: '#4AD9B8' },
};
